import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { automationsClient } from '#pplx_generated/typespec/rest/automations/client.js';
export const updateAutomationState = async ({ automationId, state, }) => {
    const { data, error, response } = await automationsClient.PATCH('/rest/automations/{automation_id}', 'update-automation-state', {
        params: {
            path: {
                automation_id: automationId,
            },
        },
        body: { state },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to update automation state',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=updateAutomationState.js.map